<script setup lang="ts">
    const { contactSupport } = useIntercom();
    const { $tracker } = useNuxtApp();

    defineProps({
        collapsed: {
            type: Boolean,
            required: false,
        },
        isBurger: {
            type: Boolean,
            default: false,
        },
    });

    // The Intercom launcher is hidden on mobile (see base.vue) — this menu
    // entry is its replacement and opens the conversation directly.
    const openSupport = () => {
        $tracker.track('sidebar_support_click');
        contactSupport();
    };
</script>

<template>
    <button
        type="button"
        class="relative flex transition-all rounded-md pl-2 pr-3 py-[6px] text-left w-full md:hover:bg-branding-rich-black"
        :class="[collapsed ? 'w-10' : 'w-full']"
        @click="openSupport"
    >
        <div
            class="text-xl gap-3 flex flex-row items-center w-full min-w-0"
            :class="isBurger ? 'text-black' : 'text-white'"
        >
            <i
                class="fa-jelly fa-circle-question text-base w-[26px] text-center flex-shrink-0"
                aria-hidden="true"
            />
            <transition
                enter-active-class="transition-all duration-100 ease-out"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="transition-all duration-100 ease-out delay-150"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <span
                    v-if="!collapsed"
                    class="text-sm font-inter text-nowrap max-md:font-medium truncate"
                >
                    {{ $t('layout.header.help.support') }}
                </span>
            </transition>
        </div>
    </button>
</template>
